// dependences
import Vue from 'vue';
import VueI18n from 'vue-i18n';

// languages
import EN_US from './languages/en_us.json';
import ES_AR from './languages/es_ar.json';
import ES_CL from './languages/es_cl.json';
import ES_ES from './languages/es_es.json';
import ES_MX from './languages/es_mx.json';
import PT_BR from './languages/pt_br.json';

Vue.use(VueI18n);

// False request for get Cloudflare value
var req = new XMLHttpRequest();
req.open('GET', document.location, false);
req.send(null);
var headers = req.getAllResponseHeaders().toLowerCase();
var arr = headers.trim().split(/[\r\n]+/);

// Create a map of header names to values
var headerMap = {};
arr.forEach(function (line) {
  var parts = line.split(': ');
  var header = parts.shift();
  var value = parts.join(': ');
  headerMap[header] = value;
});

var browserLanguageDetection = (function(code) {
  switch(code) {
    case 'cl':
      return 'es-CL';
    case 'mx':
      return 'es-MX';
    case 'ar':
      return 'es-AR';
    case 'es':
      return 'es-ES';
    case 'us':
      return 'en-US';
    case 'br':
      return 'pt-BR';
    default:
      return 'es-CL'; // default
  }
})(headerMap.country);

const locale = browserLanguageDetection;
const messages = {
  'en-US': EN_US,
  'es-AR': ES_AR,
  'es-CL': ES_CL,
  'es-MX': ES_ES,
  'es-ES': ES_MX,
  'pt-BR': PT_BR,
};

const i18n = new VueI18n({
  locale,
  messages,
});

export default i18n;



// WEBPACK FOOTER //
// ./src/lang/lang.js